module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Design/Pen&ruller-514e45feff08dbe2c4794f7164e61248.svg";